<div
  class="border border-outline dark:border-outline-darkmode rounded-lg py-5 px-6 flex flex-col gap-5 w-full"
>
  <div class="flex gap-2 items-center">
    <ui-skeleton class="flex-1 inline-block h-4 w-[80%] rounded-full" />
    <ui-skeleton class="flex-none inline-block size-8 rounded-md" />
  </div>
  <ul class="flex flex-col gap-3">
    <li
      class="flex gap-1.5 items-center px-3.5 py-2.5 border border-outline dark:border-outline-darkmode rounded-md"
    >
      <ui-skeleton class="inline-block h-4 w-full rounded-full" />
    </li>
    <li
      class="flex gap-1.5 items-center px-3.5 py-2.5 border border-outline dark:border-outline-darkmode rounded-md"
    >
      <ui-skeleton class="inline-block h-4 w-full rounded-full" />
    </li>
    <li
      class="flex gap-1.5 items-center px-3.5 py-2.5 border border-outline dark:border-outline-darkmode rounded-md"
    >
      <ui-skeleton class="inline-block h-4 w-full rounded-full" />
    </li>
    <li
      class="flex gap-1.5 items-center px-3.5 py-2.5 border border-outline dark:border-outline-darkmode rounded-md"
    >
      <ui-skeleton class="inline-block h-4 w-full rounded-full" />
    </li>
  </ul>
</div>
